import Input from "./Input";

class Selects extends Input {
    constructor(element, form) {
        super(element, form);
        this.inputElement = this.element?.querySelector('select');
        this.name = this.inputElement.name;
        this._value = this.inputElement.value;
        if (this.inputElement.required) {
            this.validations.push('required');
        }
        this.addListeners();
    }

    addListeners() {
        this.inputElement.addEventListener('change', (e) => {
            this.value = e.target.value;
            this.validate();
        });
    }

    reset() {
        this.value = '';
        this.removeError();
        
        const valueElements = this.element.querySelectorAll('[data-list-value]');
        const currentValue = this.element.querySelector('.select-component__value');
        const placeHolder = currentValue.dataset.placeholder;
        currentValue.innerHTML = placeHolder;

        Array.from(valueElements).find(el => {
            if (el.classList.contains('disable')) {
                el.classList.remove('disable');
            }
        });

    }
}

export default Selects;